var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-header',{attrs:{"titleSize":8,"title":"Central de Ofertas","title-link":"#","map":['Mercado Libre', 'Integraciones']}}),_c('mercado-libre-select-integration',{attrs:{"url-name":"MercadoLibrePromotionsIndex"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }